import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Table } from "../../style";

export function Phytase(props) {
  return (
    <Table>
      <Header>
        <tr>
          <th style={{ width: "185px" }}>
            <span></span>
          </th>
          <th>
            <span>Qual Produto?</span>
          </th>
        </tr>
      </Header>
      <Body>
        <tr>
          <td>Pré</td>
          <td>
            <Input
              type="inputOnly"
              params="enzymes.phytase.pre.product"
              item={props.megg}
              setItem={props.setMegg}
              placeholder="Digite o Produto"
            />
          </td>
        </tr>
        <tr>
          <td>Inicial</td>
          <td>
            <Input
              type="inputOnly"
              params="enzymes.phytase.initial.product"
              item={props.megg}
              setItem={props.setMegg}
              placeholder="Digite o Produto"
            />
          </td>
        </tr>
        <tr>
          <td>Crescimento</td>
          <td>
            <Input
              type="inputOnly"
              params="enzymes.phytase.growth.product"
              item={props.megg}
              setItem={props.setMegg}
              placeholder="Digite o Produto"
            />
          </td>
        </tr>
        <tr>
          <td>Desenvolvimento</td>
          <td>
            <Input
              type="inputOnly"
              params="enzymes.phytase.development.product"
              item={props.megg}
              setItem={props.setMegg}
              placeholder="Digite o Produto"
            />
          </td>
        </tr>
      </Body>
    </Table>
  );
}
